export class INSERTIONCONSTANTS {
    public static ELEMENT = '6a8e3d27-be7c-44a2-b943-a1868e824b1b'
    public static AREA = 'd3a2fd52-1532-40e4-a40a-d0ec2775f848'
    public static POINT = 'cca40b09-d671-4cd4-9001-1d5c7ec863cb'
}